export default __webpack_public_path__ + "static/media/transfer-icon.400df95f.svg";